<template>
  <div class="hello" id="hello">
    <div class="container">
      <div class="hello__wrapper">
        <p class="hello__title">Hello, We Are LUNATRIX LTD.</p>
        <div class="hello__inner">
          <div class="hello__item">
            <div class="hello__item-image">
              <img src="@images/helloImage1.png" alt="">
            </div>
            <p>Welcome to <b>LUNATRIX LTD.</b>, where innovation meets reliability in the realm of IT solutions. We have dedicated ourselves to empowering businesses through cutting-edge technology and tailored services that drive efficiency and growth. <b>Company’s Goal</b>: to deliver innovative IT solutions that enhance business efficiency and make people's lives easier and more comfortable. <b>Our Mission</b> is to empower businesses and individuals to unlock their potential through digital technology. Our products and services ensure reliability, security, and growth—transforming complex challenges into simple and elegant solutions.</p>
          </div>
          <div class="hello__item">
            <div class="hello__item-image">
              <img src="@images/helloImage2.png" alt="">
            </div>
            <p>We believe that technology should work for you, not the other way around. Staying ahead in a rapidly evolving digital landscape, we continuously adapt and grow alongside emerging technologies. From AI to next-gen cybersecurity, we ensure our clients always have access to cutting-edge tools and strategies. From small startups to large enterprises, we partner with organizations of all sizes to provide customized services, including cloud computing, cybersecurity, software development, data analytics, and IT consultancy and etc. <b>By embracing change and driving progress, we don’t just follow trends—we help shape them</b>. If you haven't found what you need, just contact us.</p>
          </div>
          <div class="hello__item">
            <div class="hello__item-image">
              <img src="@images/helloImage3.png" alt="">
            </div>
            <p>We know your business is one-of-a-kind – and so is your time. That’s why we don’t offer generic solutions, but instead focus on efficient collaboration and smart customization. Our process begins with truly listening to your needs, allowing us to quickly identify the most effective path forward. <b>By valuing both your unique requirements and your time, we become more than vendors – we become trusted partners in your growth</b>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.hello {
  border-radius: 24px;
  position: relative;
  top: -20px;
  background-color: $white;
  z-index: 1;

  &__wrapper {
    padding-block: 80px;
  }

  &__title {
    text-align: center;
    color: #272343;
    font-size: 52px;
    font-weight: 900;
    text-transform: capitalize;
  }

  &__inner {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    gap: 65px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 50px;
    
    &:nth-child(2) {
      flex-direction: row-reverse;

      & div {
        & img {
          padding-right: 0;
          padding-left: 45px;
          border-left: 2px solid #029FAE;
          border-right: none;
        }

        &::before {
          right: -250px;
          left: unset;
          background: linear-gradient(270deg, #EAF5FF 0%, #8AB8E5 100%);
        }
      }

      & p {
        text-align: right;
      }
    }

    &-image {
      position: relative;

      & img {
        width: 300px;
        padding-right: 45px;
        border-right: 2px solid #029FAE;
        position: relative;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -250px;
        width: 100%;
        height: 89%;
        background: linear-gradient(270deg, #8AB8E5 0%, #EAF5FF 100%);
      }
    }

    & p {
      color: #636270;
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
    }
  }
}

@media (max-width: 1000px) {
  .hello {
    &__item {
      & p {
        font-size: 14px;
      }

      &-image {
        &::before {
          left: -200px;
        }

        & img {
          width: 250px;
        }
      }

      &:nth-child(2) {
        & div {
          &::before {
            right: -200px;
          }
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .hello {
    &__item {
      flex-direction: column;

      & div {
         & img {
           border-bottom: 2px solid #029FAE;
           padding-left: 0 !important;
           padding-right: 0 !important;
           border-right: none !important;
           border-left: none !important;
         }
      }

      &:nth-child(2) {
        flex-direction: column;
      }

      &-image::before {
        display: none;
      }

      & p {
        text-align: center !important;
      }
    }
  }
}
</style>